module.exports = __webpack_public_path__ + "static/media/DefaultImage.6a9d678d.png";